<div *ngIf="event" class="description" [class.closed]="closed">
  {{ event.details.description }}
  <dgx-components-icon mr-3 [icon]="event.details.icon" />
</div>
